






























































































import { DeviceManagementActions } from '@/constants/device-management'

export default {
  props: {
    stageIndex: {
      type: Number,
      required: true,
    },
    deviceManagementAction: {
      type: String,
      required: true,
    },
    currentGatewayId: {
      type: String,
      required: true,
    },
    allDevices: {
      type: Array,
      required: true,
    },
    selectedDevices: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      isAttemptingGatewayReboot: false,
      hasAttemptedGatewayReboot: false,
      hasSuccessfulGatewayReboot: false,
      isAttemptingDeviceDataConnection: false,
      currentDeviceForDataConnectionIndex: 0,
      currentDeviceHasDataConnectionFailure: false,
    }
  },

  computed: {
    isCreatePackageAction() {
      return this.deviceManagementAction === DeviceManagementActions.CreatePackage
    },
    devicesForDataConnection() {
      return this.selectedDevices.filter(
        device =>
          !device.hasSkippedGatewayConnection && !device.hasSkippedDataConnection && !device.hasSuccessfulDataConnection
      )
    },
    devicesWithFailedDataConnection() {
      return this.selectedDevices.filter(
        device => device.hasAttemptedDataConnection && !device.hasSuccessfulDataConnection
      )
    },
    devicesWithSuccessfulDataConnection() {
      return this.selectedDevices.filter(device => device.hasSuccessfulDataConnection)
    },
    allDevicesHaveAttemptedDataConnection() {
      return this.devicesForDataConnection.length === 0
    },
    allDevicesHaveSuccessfulDataConnection() {
      return this.allDevicesHaveAttemptedDataConnection && this.devicesWithFailedDataConnection.length === 0
    },
    allDevicesHaveFailedDataConnection() {
      return this.allDevicesHaveAttemptedDataConnection && this.devicesWithSuccessfulDataConnection.length === 0
    },
    someDevicesHaveSuccessfulDataConnection() {
      return (
        this.allDevicesHaveAttemptedDataConnection &&
        !this.allDevicesHaveSuccessfulDataConnection &&
        !this.allDevicesHaveFailedDataConnection
      )
    },
    currentDeviceForDataConnection() {
      return this.devicesForDataConnection[0]
    },
    requestInProgress() {
      return this.isAttemptingGatewayReboot || this.isAttemptingDeviceDataConnection
    },
    requestInProgressText() {
      if (!this.currentDeviceForDataConnection) return ''
      return this.isAttemptingGatewayReboot
        ? 'Gateway is now rebooting'
        : `Checking data connectivity of ${this.currentDeviceForDataConnection.name}`
    },
    packageCreationSummary() {
      const summaryVerb = this.isCreatePackageAction ? 'created' : 'updated'
      const success = this.allDevicesHaveSuccessfulDataConnection
      const partialSuccess = this.someDevicesHaveSuccessfulDataConnection
      const failure = this.allDevicesHaveFailedDataConnection
      return {
        icon: failure ? 'mdi-close-circle-outline' : 'mdi-check-circle-outline',
        iconColor: failure ? 'red' : 'green',
        text: success
          ? `has been successfully ${summaryVerb}`
          : partialSuccess
          ? `has been successfully ${summaryVerb}, but a data connection to one or more devices could not be established`
          : `could not be ${summaryVerb}. Please try again`,
        showDevicesWithSuccessfulDataConnection: success || partialSuccess,
        showDevicesWithFailedDataConnection: partialSuccess,
      }
    },
  },

  watch: {
    devicesForDataConnection: {
      handler(newArr, oldArr) {
        if (this.allDevicesHaveAttemptedDataConnection) {
          this.$emit('stageIsValid', {
            stageIndex: this.stageIndex,
            isValid: true,
          })
          return
        }
        this.$emit('stageIsValid', {
          stageIndex: this.stageIndex,
          isValid: false,
        })
        this.attemptDeviceDataConnection()
      },
    },
  },

  async mounted() {
    this.rebootGateway()
    setTimeout(() => {
      this.attemptDeviceDataConnection()
    }, 4000)
  },

  methods: {
    async rebootGateway() {
      try {
        console.info('this function will attempt to reboot the gateway')
        this.isAttemptingGatewayReboot = true
        setTimeout(() => {
          this.isAttemptingGatewayReboot = false
          this.hasAttemptedGatewayReboot = true

          this.hasSuccessfulGatewayReboot = true

          //this.hasSuccessfulGatewayReboot = false;
        }, 4000)
      } catch (err) {
        console.log(err)
      }
    },
    async attemptDeviceDataConnection() {
      try {
        console.info(
          `this function will test data connectivity for ${this.currentDeviceForDataConnection.name} ${this.currentDeviceForDataConnection.deviceId}`
        )
        this.currentDeviceHasDataConnectionFailure = false
        this.isAttemptingDeviceDataConnection = true
        setTimeout(() => {
          if (this.currentDeviceForDataConnection.name === 'Scale') {
            this.currentDeviceHasDataConnectionFailure = true
            this.isAttemptingDeviceDataConnection = false
            return
          }
          this.$emit('setDeviceDataConnection', {
            ...this.currentDeviceForDataConnection,
            hasAttemptedDataConnection: true,
            hasSuccessfulDataConnection: true,
          })
          this.isAttemptingDeviceDataConnection = false
        }, 4000)
      } catch (err) {
        console.log(err)
      }
    },
    skipDataConnectionForCurrentDevice() {
      this.$emit('setDeviceDataConnection', {
        ...this.currentDeviceForDataConnection,
        hasAttemptedDataConnection: true,
        hasSkippedDataConnection: true,
      })
      this.currentDeviceHasDataConnectionFailure = false
    },
  },
}
